import React from 'react';
import { Link, useLocation, useParams } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import './Breadcrumb.css';

const Breadcrumb = () => {
  const location = useLocation();
  const { patientId } = useParams();

  // Generate breadcrumb items based on current route
  const getBreadcrumbItems = () => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const items = [];

    // Debug logging
    console.log('Breadcrumb Debug:', {
      pathname: location.pathname,
      pathSegments,
      patientId,
      hasPatient: pathSegments[0] === 'patient',
      hasAnalytics: pathSegments[0] === 'analytics'
    });

        // Handle patient pages - these are sub-pages of Patients
        if (pathSegments[0] === 'patient' && patientId) {
          items.push({
            label: 'Patients',
            path: '/users'
          });
      
      items.push({
        label: `Patient ${patientId}`,
        path: `/patient/${patientId}`,
        isActive: true
      });
    }

    // Handle analytics pages - these are sub-pages of Overview
    if (pathSegments[0] === 'analytics') {
      items.push({
        label: 'Overview',
        path: '/',
        icon: <Home size={16} />
      });
      
      const analyticsType = pathSegments[1];
      if (analyticsType) {
        items.push({
          label: `${analyticsType.charAt(0).toUpperCase() + analyticsType.slice(1)} Analytics`,
          path: `/analytics/${analyticsType}`,
          isActive: true
        });
      }
    }

    console.log('Breadcrumb items:', items);
    return items;
  };

  const breadcrumbItems = getBreadcrumbItems();

  // Don't show breadcrumbs on top-level pages (Overview and Users)
  if (location.pathname === '/' || location.pathname === '/overview' || location.pathname === '/users') {
    console.log('Hiding breadcrumbs - top level page:', location.pathname);
    return null;
  }

  // Don't show breadcrumbs if no items to display
  if (breadcrumbItems.length === 0) {
    console.log('Hiding breadcrumbs - no items to display');
    return null;
  }

  console.log('Rendering breadcrumbs with items:', breadcrumbItems);

  return (
    <nav className="breadcrumb">
      <div className="breadcrumb-container">
        {breadcrumbItems.map((item, index) => (
          <div key={item.path} className="breadcrumb-item">
            {index > 0 && (
              <ChevronRight size={16} className="breadcrumb-separator" />
            )}
            
            {item.isActive ? (
              <span className="breadcrumb-current">
                {item.icon && <span className="breadcrumb-icon">{item.icon}</span>}
                {item.label}
              </span>
            ) : (
              <Link to={item.path} className="breadcrumb-link">
                {item.icon && <span className="breadcrumb-icon">{item.icon}</span>}
                {item.label}
              </Link>
            )}
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumb;



